import { render, staticRenderFns } from "./DialogEditorDoctor.vue?vue&type=template&id=01231107&scoped=true&"
import script from "./DialogEditorDoctor.vue?vue&type=script&lang=js&"
export * from "./DialogEditorDoctor.vue?vue&type=script&lang=js&"
import style0 from "./DialogEditorDoctor.vue?vue&type=style&index=0&id=01231107&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01231107",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardActions,VContainer,VFlex,VIcon,VLayout,VSpacer,VTooltip})
